import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WreNotification, WreNotificationType } from '../../../../../models/notification';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafrManagementService } from './../../../../../admin-portal/admin/services/safr-management.service';
import { Field } from './../../../../../admin-portal/admin/models/safr-type';
import { Subscription } from 'rxjs';
import { ConfirmationService } from './../../../../../shared/services/confirmation.service';
import { confirmationTitles, confirmationMessages, confirmationTexts } from './../../../../../shared/enums/confirmation';
import { EditReviewerComponent } from '../edit-reviewer/edit-reviewer.component';
import { EditFieldComponent } from '../edit-field/edit-field.component';

@Component({
    selector: 'wre-edit-modal',
    templateUrl: './edit-modal.component.html',
    styleUrls: ['./edit-modal.component.sass'],
    standalone: false
})
export class EditModalComponent implements OnInit, OnDestroy {

  @ViewChild(EditReviewerComponent) childReviewerComponent!: EditReviewerComponent;
  @ViewChild(EditFieldComponent) childFieldComponent!: EditFieldComponent;

  private _loading = false;
  private _field: Field = new Field();

  errorMessage = false;
  fieldId: string;
  subscription: Subscription;
  notification: WreNotification;
  message: string;
  genericError = 'An error has occurred. Please contact administrator.';
  duplicateError = 'A value already exists with this name. Values must be unique.';

  get loading(): boolean { return this._loading; }

  get field(): Field { return this._field; }

  get isReviewer() {
    return this.field && this.field.name === 'Reviewer' && !this.loading;
  }

  get isDisabled() {
    return this.isReviewer
      ? this.childReviewerComponent ? this.childReviewerComponent.isDisabled() : true
      : this.childFieldComponent ? this.childFieldComponent.isDisabled() : true;
  }

  constructor(
    public _activeModal: NgbActiveModal,
    private _safrManagementService: SafrManagementService, 
    private _confirmationService: ConfirmationService) { }

  ngOnInit() {
    this._loading = true;
    this._safrManagementService.fields$.subscribe(fields => {
      this._field = fields.find(f => f.id === this.fieldId);
      this._loading = false;
    })
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  confirmClose() {
    if (this.isDisabled) {
      this.closeModal();
      return;
    }

    this.subscription = this._confirmationService
      .openModal(confirmationTitles.defaultTitle, confirmationMessages.defaultMessage, confirmationTexts.defaultConfirmationText)
      .subscribe((close: boolean) => {
      if (close) {
        this._confirmationService.closeModal();
        this.closeModal();
      }
    });
  }

  closeModal() {
    this._activeModal.close();
  }

  async saveChanges() {
    if (this.isReviewer) {
      this.childReviewerComponent.saveChanges();
    } else {
      this.childFieldComponent.saveChanges();
    }
	}

  handleError(error: any): any {
		console.error(error);
    this.errorMessage = true;
		this.message = error.error;
    this.message = error.error.status === 409
      ? this.duplicateError
      : this.genericError;
		const notification = new WreNotification(WreNotificationType.error, this.message);
		this.notify(notification);
	}

  private notify(notification: WreNotification) {
		this.notification = notification;
		setTimeout(() => this.notification = null, 5000);
	}
}


